interface Props {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
}

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'del', '0', 'ok'] as const;

/**
 * Zifferneingabe als eigene Tastatur statt Systemtastatur.
 *
 * Grund: die Bedienung erfolgt einhändig im Stehen. Grosse Flächen, keine
 * Umschalttasten, kein Aufklappen und Zuklappen der Systemtastatur, das
 * jedes Mal die Hälfte des Bildschirms verschiebt.
 */
export function Numpad({ value, onChange, onSubmit, disabled }: Props) {
  function press(key: (typeof KEYS)[number]): void {
    if (disabled) return;
    if (key === 'del') return onChange(value.slice(0, -1));
    if (key === 'ok') return onSubmit();
    // Sehr lange Eingaben entstehen nur durch Verklicken.
    if (value.length >= 24) return;
    onChange(value + key);
  }

  return (
    <div class="numpad" role="group" aria-label="Zifferneingabe">
      {KEYS.map((key) => (
        <button
          key={key}
          class={`numpad__key ${key === 'ok' ? 'numpad__key--ok' : ''}`}
          onClick={() => press(key)}
          disabled={disabled}
          aria-label={key === 'del' ? 'Löschen' : key === 'ok' ? 'Prüfen' : key}
        >
          {key === 'del' ? '⌫' : key === 'ok' ? 'Prüfen' : key}
        </button>
      ))}
    </div>
  );
}
